import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAddServiceAttachment, IServiceAttachment, IUpdateServiceAttachment } from '../models/service-attachment';

@Injectable({
    providedIn: 'root'
})
export class ServiceAttachmentService {

    constructor(private http: HttpClient) { }

    addServiceAttachment(request: IAddServiceAttachment){
        return this.http.post<IServiceAttachment>(
            `${environment.baseUrl}/v1/ServiceAttachments/createServiceAttachment`,
            request
        )
    }

    deleteServiceAttachment(id :string){
        return this.http.delete(
            `${environment.baseUrl}/v1/ServiceAttachments/deleteServiceAttachment/${id}`
        )
    }

    updateServiceAttachment(request: IUpdateServiceAttachment){
        return this.http.put<IServiceAttachment>(
            `${environment.baseUrl}/v1/ServiceAttachments/updateServiceAttachment/${request.id}`,
            request
        )
    }
}